// extracted by mini-css-extract-plugin
module.exports = {"requiredIndicator":"src-components-RequiredIndicator-styles___requiredIndicator"};